import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f114fa56"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bottom-btn-group"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("查看站点详情")

import { computed } from 'vue'
import { HButton } from '@nio-fe/horo-h5'
// import { OutletsModel } from '../../models/outlets.model'
import { nioJsBridge } from '@nio-wad/universal-bridge-h5'
import { useRoute } from 'vue-router'
import { isInApp } from '@nio-wad/hooks'
import { PointType } from '../../contract/map'
import { useComponentStore } from '../../nsh5/localStores/component'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const componentStore = useComponentStore()
const dataSource = computed(() => {
  return componentStore.dataSource
})

const show = computed(() => {
  return (
    isInApp &&
    route.name == 'resource' &&
    (route.query.pointType === PointType.Recharge ||
      route.query.pointType === PointType.RechargePS ||
      route.query.pointType === PointType.RechargeCS) &&
    dataSource.value?.id
  )
})

const brand = (process.config as any).brand

// sub_type ChargeStation/PowerSwap/PowerSwapClone/food/accommodation/experience/nio_house/nio_space/car_wash
const schemeMap: Record<string, string> = {
  nio: 'nio://service/charge_map?id=${id}&sub_type=${sub_type}',
  alps: 'onvo://mapmodule/maphome?id=${id}&sub_type=${sub_type}',
  fy: 'fy://mapmodule/maphome?id=${id}&sub_type=${sub_type}',
}

const subTypeMap: Record<string, string> = {
  ChargeStation: 'ChargeStation',
  PowerSwap: 'PowerSwap',
  nio_house: 'nio_house',
  nio_space: 'nio_space',
}

const showDetail = () => {
  console.log('===============dataSource=====================')
  console.log(dataSource)
  console.log('====================================')
  const link = schemeMap[brand]
    .replace('${id}', dataSource.value?.id || '')
    .replace('${sub_type}', subTypeMap[dataSource.value?.type] || '')
  console.log('===============link=====================')
  console.log(link)
  console.log('====================================')
  nioJsBridge.openURL({
    data: {
      url: link,
    },
  })
}

return (_ctx: any,_cache: any) => {
  return (_unref(show))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(HButton), {
          class: "btn",
          round: "",
          type: "secondary",
          block: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showDetail()))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})